'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hubspot = require('hubspot');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var flagsImagePath = (_hubspot2.default.bender && _hubspot2.default.bender.staticDomainPrefix) + '/ui-addon-i18n/static-1.2379/img/flags.png';

exports.default = _react2.default.createClass({
  displayName: 'CountryFlag',

  propTypes: {
    countryCode: _react.PropTypes.string.isRequired
  },

  getFlagStyle: function getFlagStyle() {
    return {
      backgroundImage: 'url(' + flagsImagePath + ')'
    };
  },
  render: function render() {
    var _props = this.props,
        countryCode = _props.countryCode,
        className = _props.className,
        passThroughProps = _objectWithoutProperties(_props, ['countryCode', 'className']);

    return _react2.default.createElement('span', _extends({}, passThroughProps, {
      className: (0, _classNames2.default)('country-flag', className, countryCode.toLowerCase()),
      style: this.getFlagStyle()
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.2379/js/internal/components/CountryFlag.js
// module id = 297
// module chunks = 3 4 5